"use strict"

/**
 * @enum PackageCompanyType
 */
let PackageCompanyType
(function (packageCompanyType) {
packageCompanyType.None = 0
packageCompanyType[0] = "None"
packageCompanyType.IranRadiator = 1
packageCompanyType[1] = "IranRadiator"
packageCompanyType.EemerGaz = 2
packageCompanyType[2] = "EemerGaz"
packageCompanyType.Lorg = 3
packageCompanyType[3] = "Lorg"
packageCompanyType.Bootaan = 4
packageCompanyType[4] = "Bootaan"
packageCompanyType.ShofazhKar = 5
packageCompanyType[5] = "ShofazhKar"
packageCompanyType.NahadTalash = 6
packageCompanyType[6] = "NahadTalash"
packageCompanyType.Aron = 7
packageCompanyType[7] = "Aron"
packageCompanyType.AirTemp = 8
packageCompanyType[8] = "AirTemp"
packageCompanyType.MegaTerm = 9
packageCompanyType[9] = "MegaTerm"
packageCompanyType.Azar = 10
packageCompanyType[10] = "Azar"
packageCompanyType.MashhadTahvieh = 11
packageCompanyType[11] = "MashhadTahvieh"
packageCompanyType.Pishgaman = 12
packageCompanyType[12] = "Pishgaman"
packageCompanyType.DanErtebat = 13
packageCompanyType[13] = "DanErtebat"
packageCompanyType.Barli = 14
packageCompanyType[14] = "Barli"
packageCompanyType.NewWarm = 15
packageCompanyType[15] = "NewWarm"
packageCompanyType.SGP = 16
packageCompanyType[16] = "SGP"
packageCompanyType.Hamgam = 17
packageCompanyType[17] = "Hamgam"
packageCompanyType.Aritson = 18
packageCompanyType[18] = "Aritson"
packageCompanyType.Istatis = 19
packageCompanyType[19] = "Istatis"
packageCompanyType.Taash = 20
packageCompanyType[20] = "Taash"
packageCompanyType.Agraa = 21
packageCompanyType[21] = "Agraa"
packageCompanyType.Alzaan = 22
packageCompanyType[22] = "Alzaan"
packageCompanyType.Emcoo = 23
packageCompanyType[23] = "Emcoo"
packageCompanyType.Raziantii = 24
packageCompanyType[24] = "Raziantii"
packageCompanyType.Vizman = 25
packageCompanyType[25] = "Vizman"
packageCompanyType.Kuber = 26
packageCompanyType[26] = "Kuber"
packageCompanyType.Altai = 27
packageCompanyType[27] = "Altai"
packageCompanyType.Tachi = 28
packageCompanyType[28] = "Tachi"
packageCompanyType.Estambol = 29
packageCompanyType[29] = "Estambol"
packageCompanyType.Froli = 30
packageCompanyType[30] = "Froli"
packageCompanyType.Merkori = 31
packageCompanyType[31] = "Merkori"
packageCompanyType.Garmiran = 32
packageCompanyType[32] = "Garmiran"
packageCompanyType.Baxi = 33
packageCompanyType[33] = "Baxi"
packageCompanyType.Unical = 34
packageCompanyType[34] = "Unical"
packageCompanyType.IranShargh = 35
packageCompanyType[35] = "IranShargh"
packageCompanyType.Haylan = 36
packageCompanyType[36] = "Haylan"
packageCompanyType.AtaPipe = 37
packageCompanyType[37] = "AtaPipe"
packageCompanyType.Mabna = 38
packageCompanyType[38] = "Mabna"
})(PackageCompanyType || (PackageCompanyType = {}))

export { PackageCompanyType }
